module.exports = __webpack_public_path__ + "img/2x.6efc06b.jpg";